<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <ServiceForm :formProps="formProps">
                </ServiceForm>
            </template>
            <template #search="searchProps">
                <ServiceSearch :searchProps="searchProps">
                </ServiceSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import ServiceForm from './ServiceForm.vue'
import ServiceSearch from './ServiceSearch.vue'
import { ref } from "vue";
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __ } from '@pages/Helper/utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
